module.exports = __webpack_public_path__ + "img/specials-slider-6040-cjdr.e75453ef.jpg";